import InfoTool from './InfoTool.js';
import ZoomControl from './ZoomControl.js';
import Zoom2LonLat from './Zoom2LonLat.js';
import Print from './Print.js';
import Draw from './Draw.js'; // was "Measure.js" in previous versions
import Buffer from './Buffer.js';
import FeatureBuffer from './FeatureBuffer.js';
import ModifyVectorFeature from './ModifyVectorFeature.js';
import GeoLocator from './GeoLocator.js';
import {changePage} from './changePage.js';
import JumpToMenuW3 from './JumpToMenuW3.js';

/**
 * Constructor
 */

export default function(map) {
  var activeTool = '';
  var infoTool;
  const zoombox = new ZoomControl(map); // shouldn't create unless it's in toolmenu
  var zoom2ll;
  var geolocation;
  var buffer;
  var featureBuffer;
  var meas;
  var modify;

  if (!rwg.config.navbar) rwg.config.navbar = {};
  const toolList = rwg.config.navbar.tools ||
    ['zoominbox', 'zoomoutbox', 'pan', 'infobox', 'geoloc', 'measline', 'measarea', 'clear', 'zoom2ll', 'buffer', 'help']; // typical county defaults
    // additional options: 'meascircle', 'changeclient', 'trav', 'logout', 'lyropts' (not currently implemented)

  if (toolList.includes('infobox')) {
    infoTool = new InfoTool(map);
  } else {
    // dummy function so that calls to infoTool() won't cause errors
    infoTool = function(mode) {}; // eslint-disable-line no-unused-vars
    document.querySelectorAll('[data-tool=infobox]').forEach(elem => elem.style.display = 'none');
  }

  if (rwg.config.navbar.hasOwnProperty('jump2s')) {
    new JumpToMenuW3({
      element: document.querySelector('#jump-menu-items'),
      list: rwg.config.navbar.jump2s,
    });
  } else {
    document.querySelector('#jump2menu').style.display='none';
  }

  if (toolList.includes('zoom2ll')) {
    zoom2ll = new Zoom2LonLat(map);
  } else {
    document.querySelector('[data-tool="zoom2ll"]').style.display = 'none';
  }

  geolocation = new GeoLocator(map, rwg.cs, rwg.config.saveTrack);
  map.addLayer(geolocation.olLayer);

  if (toolList.includes('trav')) {
    // trav = new Trav(map);
  } else {
    document.querySelector('[data-tool="trav"]').style.display = 'none';
  }

  if (toolList.includes('measline') || toolList.includes('measarea')) {
    meas = new Draw(map);
    // for now the circle tool must be explicitly requested in rwg.config.navbar.tools
    if (toolList.includes('meascircle')) {
      document.querySelectorAll('[data-tool="meascircle"]').forEach(elem => (elem.style.display = ''));
    } else {
      // document.querySelectorAll('[data-tool="meascircle"]').forEach(elem => (elem.style.display = 'none'));
      document.querySelectorAll('[data-tool="meascircle"]').forEach(elem => elem.remove());
    }
  } else {
    // dummy function so that calls to meas() won't cause errors
    meas = function(mode) {}; // eslint-disable-line no-unused-vars
    // the  ^=  below means "starts with", sort of like a regex but not really
    document.querySelectorAll('[data-tool^=meas]').forEach(elem => (elem.style.display = 'none'));
  }

  if (toolList.includes('buffer')) {
    buffer = new Buffer(map);
  } else {
    document.querySelector('[data-tool="buffer"]').style.display = 'none';
  }

  if (toolList.includes('featurebuffer') || (rwg.config.featureBufferLayers && rwg.config.featureBufferLayers.length)) {
    featureBuffer = new FeatureBuffer(map);
    // add menu item dynamically if not already in HTML
    if (!document.querySelector('[data-tool="featurebuffer"]')) {
      let a = document.createElement('a');
      a.setAttribute('data-tool', 'featurebuffer');
      a.className = 'menu-item featurebuffer';
      a.href = '#';
      a.title = 'Buffer around a map feature (road, river, etc.)';
      a.textContent = 'Feature Buffer';
      let toolMenuItems = document.querySelector('#tool-menu-items');
      let bufferItem = document.querySelector('[data-tool="buffer"]');
      if (bufferItem && bufferItem.nextSibling) {
        toolMenuItems.insertBefore(a, bufferItem.nextSibling);
      } else if (toolMenuItems) {
        toolMenuItems.appendChild(a);
      }
      // register click handler (same as other menu-items)
      a.addEventListener('click', function(evt) {
        evt.preventDefault();
        closeMenu(evt);
        setToolActive(this);
      });
    }
  }

  if (rwg.config.fullDrawing) {
    modify = new ModifyVectorFeature();
  } else {
    // dummy function so that calls to modify() won't cause errors
    modify = function(mode) {}; // eslint-disable-line no-unused-vars
    // hide drawing tools
    document.querySelectorAll('[data-tool="select"]').forEach(elem => (elem.style.display = 'none'));
    document.querySelectorAll('[data-tool="pointText"]').forEach(elem => (elem.style.display = 'none'));
  }

  if (!toolList.includes('clear')) {
    document.querySelectorAll('[data-tool="clear"]').forEach(elem => (elem.style.display = 'none'));
  }

  if (toolList.includes('changeclient')) { // for cpc
    document.querySelector('[data-tool="changeclient"]').style.display = '';
  } else {
    // document.querySelector('[data-tool="changeclient"]').style.display = 'none';
    document.querySelector('[data-tool="changeclient"]').remove()
  }

  if (rwg.config.navbar.search === false) {
    document.getElementById('nav-search-li').remove();
    document.querySelector('button[data-tool="search"]').remove();  // mobile view button
  } else {
    // called by the navbar search
    // copies the navbar search term into the regular text search form and submits it
    let navbarSearchForm = document.querySelector('form#nav-search');
    if (navbarSearchForm) {
      navbarSearchForm.addEventListener('submit', function(event) {
        event.preventDefault();
        // make sure text search is selected not advanced search
        document.querySelector('button[rwg-tab="srch-txt"]').click();
        // copy value from nav-bar search from into search tab form
        document.querySelector('#ts').value = document.querySelector('#search-text').value;
        document
          .querySelector('#searchForm')
          .querySelector('button[type="submit"]')
          .click(); // gotta do a click() on the button, not a submit() on the form
      });
    }
  }

  // printing isn't actually controlled by the tool manager, it has its
  // own tab, but this still seems like a logical place to initialize it.
  new Print();

  document.querySelectorAll('.olButton').forEach(function(element) {
    element.addEventListener('click', function(evt) {
      // evt.preventDefault();
      evt.stopPropagation();

      let menuToggle = false;
      let tool = evt.target.dataset.tool;
      // see if it's a menu button, and if so, see if its menu items are already being shown
      if (tool && tool.includes('menu-button')) { // tool-menu-button || jump-menu-button
        tool.replace('button', 'items');
        menuToggle = (document.getElementById(tool.replace('button', 'items')).classList.contains('w3-show'));
      }

      closeMenu(evt);
      if (!menuToggle) {
        setToolActive(this);
      }
    });
  });

  document.querySelectorAll('.menu-item').forEach(function(element) {
    element.addEventListener('click', function(evt) {
      evt.preventDefault(); // menu items are <a/> elements so prevent their action
      // evt.stopPropagation(); // is this necessary? Does it do anything?
      closeMenu(evt);
      setToolActive(this);
    });
  });

  if (toolList.includes('logout')) {
    let anchor = document.createElement("a");
    anchor.href = location.pathname + '?action=logout'
    anchor.text = 'Log Out';
    anchor.className = 'logout';
    document.getElementById('main-tab-bar').append(anchor);
  }

  /* **************************************
   * Above is initilization code
   * below is the click hander function setToolActive()
   ************************************** */


  /**
   * menu-button click handler
   * @param {string} target
   */
  function openMenu(target) {
    document.getElementById(target).classList.add('w3-show');
    window.addEventListener('click', closeMenu, {once: true});
  }

  /**
   * called by a tool button click, a menu item click, or an event window.click event listener
   * @param {event} evt
   */
  function closeMenu(evt) {
    // console.log('in closeMenu()');
    document.querySelectorAll('.w3-dropdown-content').forEach(elem => elem.classList.remove('w3-show'));
    window.removeEventListener('click', closeMenu);
  }

  function clear() {
    if (buffer) buffer('clear');
    if (featureBuffer) featureBuffer('clear');
    map.getLayerByTitle('lyrVector').getSource().clear();
    if (!rwg.config.saveFeatures) meas('clear');
    if (zoom2ll) zoom2ll.clear();
    document.getElementById('infotool').innerHTML = '';
    rwg.filter = '';
    rwg.historyManager.push('clear');
    if (map.getLayerByTitle('lyrQuery')) map.getLayerByTitle('lyrQuery').setVisible(false);
  }

  /**
   *
   * @param {Object|string} clickedElement|toolName
   */
  function setToolActive(clickedElement) {
    let tool;
    if (clickedElement.getAttribute) {
      tool = clickedElement.getAttribute('data-tool');
    } else if (clickedElement.contentDiv) { // print layout tab activated
      if (activeTool) {
        tool = activeTool;
        toggle(activeTool);
        return;
      }
    } else {
      return;
    }

    /**
     * private, local function for tools that toggle on/off
     * @param {function} func function to call if activating
     * @param {string} mode function's mode parameter
     */
    function toggle(func, mode) {
      // some tools need to toggle, some are single click
      meas('off'); // meas('off') and meas('clear') are different!
      infoTool('off');
      zoombox('off');
      modify('off');  /* this switches away from drawing tab
      * should the tab switch actually be done in ModifyVectorFeature?
      * should we switch away from drawing tab, or simply switch the
        content of the tab from the style controls to the help info?
      */

      // deactivate the tool botton
      document.querySelectorAll('.w3-btn-bar > .w3-btn').forEach(el => el.classList.remove('active'));
      // deactivate the menu item
      document.querySelectorAll('a.menu-item').forEach(el => el.classList.remove('active'));

      if (tool !== activeTool) {  // we're activating a tool
        func(mode);
        document.querySelectorAll('.' + tool).forEach(elem => elem.classList.add('active'));
        activeTool = tool;
      } else {  // we're deactivating a tool
        infoTool('on');
        activeTool = '';
        tool = '';
      }
    }

    switch (tool) {
      case 'zoominbox':
        if (rwg.layout.get() === 'tabbed') {
          toggle(zoombox, 'in');
        } else {
          let view = map.getView();
          view.setZoom(view.getZoom() + 1);
        }
        break;
      case 'zoomoutbox':
        if (rwg.layout.get() === 'tabbed') {
          toggle(zoombox, 'out');
        } else {
          let view = map.getView();
          view.setZoom(view.getZoom() - 1);
        }
        break;
      case 'pan':
        toggle(zoombox, 'pan');
        break;
      case 'infobox':
        toggle(infoTool, 'box');
        break;
      case 'clear':
        clear();
        break;
      case 'zoom2ll':
        zoom2ll.go();
        break;
      case 'geoloc':
        geolocation.toggle();
        break;
      case 'buffer':
        buffer('buffer');
        break;
      case 'featurebuffer':
        featureBuffer('featurebuffer');
        break;
      case 'trav':
        toggle(meas, 'trav');
        break;
      case 'measline':
        toggle(meas, 'dist');
        break;
      case 'measarea':
        toggle(meas, 'area');
        break;
      case 'meascircle':
        toggle(meas, 'circle');
        break;
      case 'pointText':
        toggle(meas, 'point');
        break;
      // case 'lyropts': // I don't believe we ever call this directly, it's in its own tab now
      //   meas('styles'); // rwg.layerOptions();
      //   break;
      case 'select':
        toggle(modify, 'on');
        break;
      case 'help':
        window.open('https://gwmap.s3.amazonaws.com/www/pdf/help-desk.pdf', '_blank');
        break;
      case 'search': // for mobile only
        changePage('searchpage');
        break;
      case 'layers': // for mobile only
        changePage('layerspage');
        break;
      case 'tool-menu-button':
        openMenu('tool-menu-items');
        break;
      case 'jump-menu-button':
        openMenu('jump-menu-items');
        break;
      case 'jump':
        map.getView().fit(clickedElement.target.split(',').map(Number), map.getSize());
        break;
      default:
        infoTool('on');
        if (typeof rwgInitParams[tool] === 'function') {
          rwgInitParams[tool]();
        }
        break;
    } // switch

  } // setToolActive()

  /* *** START - change cursor style based on current action, could be in its own module ********* */

  let cursor; // saved cursor
  let mapStyle = document.getElementById('map-div').style

  // document.querySelectorAll('.ol-layer')[0].querySelector('canvas').style.cursor = 'help'
  // let mapStyle =document.querySelectorAll('.ol-layer')[0].querySelector('canvas').style
  // let mapStyle = document.getElementById('map-div').querySelector('canvas').style

  map.on('pointerdown', () => {
    cursor = mapStyle.cursor
    // cursor = document.getElementById('map-div').querySelector('canvas').style.cursor
    // console.log(cursor)
  });  // save the current cursor
  map.on('pointerup', () => mapStyle.cursor = cursor);  // restore the previous cursor
  map.on('pointerdrag', (evt) => {  // change the cursor when dragging if appropriate
    if (evt.originalEvent.shiftKey && !activeTool.includes('meas') && activeTool !== 'infobox') { // shift-drag in meas tools is freehand mode, so don't change cursor
      mapStyle.cursor = "url('https://gwmap.s3.amazonaws.com/css/img/zoomInRWG.cur'),auto"; // eslint-disable-line quotes
    } else if (evt.originalEvent.ctrlKey) {
      mapStyle.cursor = 'help';
    } else if (!activeTool.includes('zoom') && activeTool !== 'infobox') {  // not 'zoomin' or 'zoomout'
      mapStyle.cursor = "url('https://gwmap.s3.amazonaws.com/css/img/handRWG.cur'),auto"; // eslint-disable-line quotes
    }
  });

  /* *** END of cursor code ********* */

  // don't pan map unless pointer has moved at least 6 pixels
  var pointerdownPixel, pointerTimeout;
  map.on('pointerdown', function(e) {
    pointerdownPixel = e.pixel;
  });
  map.on('pointerdrag', function(e) {
    clearTimeout(pointerTimeout);
    if (Math.hypot(pointerdownPixel[0] - e.pixel[0], pointerdownPixel[1] - e.pixel[1]) < 6) {
      e.stopPropagation();
      pointerTimeout = setTimeout(function() {
        // figure out if there's an active tool and if not fire an info click here
        if (activeTool === 'default') {
          infoTool('click', e);
        }
      }, 300);
    }
  });

  if (rwg.config.activateControl) {
    // allows setting a tool active at initialization e.g. the select tool for cpc
    setToolActive(document.querySelector(`[data-tool=${rwg.config.activateControl}]`));
  }

  this.setToolActive = setToolActive;
  this.getActiveTool = function() {
    return activeTool;
  };
}
